export const iconFontAwesomeDisasterCrisisCircleRadiation = (
	<i className="fa-solid fa-circle-radiation"></i>
);
